import React from 'react';
import { ToggleButton } from 'components/Button';
import { StyledArrowRight, StyledArrowDown, TranscriptionToggleContainer } from './styles';

interface TranscriptionToggleProps {
  showTranscription: boolean;
  onToggle: () => void;
}

const TranscriptionToggle: React.FC<TranscriptionToggleProps> = ({ showTranscription, onToggle }) => (
  <TranscriptionToggleContainer>
    <ToggleButton type="button" id="toggle-transcription" onClick={onToggle} aria-label="Toggle transcription">
      {showTranscription ? <StyledArrowDown /> : <StyledArrowRight />}
      <span>{showTranscription ? 'Hide' : 'Show'}</span>
    </ToggleButton>
  </TranscriptionToggleContainer>
);

export default TranscriptionToggle;
